import React from "react";
import styles from './styles.module.css';
import {Title} from "../../../components";
const GuestReviews = () => {
	return (
		<div className={styles.main}>
			<Title text={"Guest Reviews"} large bottomLine/>
			<p className={styles.subTitle}>402 Reviews</p>
			<p className={styles.text}>hotels.com (9.4/10)</p>
			<p className={styles.text}>ebookers.com (9.2/10)</p>
			<p className={styles.text}>expadia.com (9.6/10)</p>
		</div>
	)
};
export default GuestReviews;